<template>
    <b-form-group
        :label="label"
        label-for="organizationState"
    >
        <treeselect
            id="organizationState"
            :options="states"
            noChildrenText=""
            :normalizer="normalize"
            :disable-branch-nodes="true"
            v-model="state"
            @input="change"
            valueFormat="object"
            :show-count="true"
        />
    </b-form-group>
</template>

<script>
import {BFormGroup} from 'bootstrap-vue'
import Treeselect from '@riophae/vue-treeselect'
import {SupplyChain} from "@core/api";
import {ObjectCloner} from "@core/mixins";

export default {
    mixins: [ObjectCloner],
    components: {
        BFormGroup, Treeselect
    },
    props: {
        selected: {
            type: Object,
            default() {
                return null;
            }
        },
        label: {
            default() {
                return this.$t('Component(SupplierSelector):label-organization-state');
            }
        }
    },
    data() {
        return {
            states: [],
            state: this.selected
        };
    },
    methods: {
        normalize(node) {
            return {id: node.id, label: node.title};
        },
        initStates(states) {
            states.forEach(this.initState);
            this.states = states;
        },
        initState(state) {
            if (null === state.children || (state.children && state.children.length === 0)) {
                delete state.children;
            } else if (state.children) {
                state.children.forEach(this.initState);
            }
        },
        change() {
            if (this.state !== this.selected) {
                this.$emit('input', this.state);
            }
        }
    },
    created() {
        SupplyChain.getStates().then(r => this.initStates(this.cloneObject(r.data)));
    },
    watch: {
        selected(v) {
            this.state = v;
        }
    }
}
</script>
<style lang="scss">
@import '../../../../node_modules/@riophae/vue-treeselect/dist/vue-treeselect.css';
</style>
